export default __webpack_public_path__ + "static/media/chamundi hills.3abca148.jpg";